import React, { ReactNode } from 'react';

const ErrorMessage = ({
  errorMessage,
  styles,
}: {
  errorMessage: string | ReactNode;
  styles?: string;
}) => {
  return (
    <span
      className={`mt-[3px] font-open-sans text-[12px] font-normal text-utility-error-danger ${styles}`}
      aria-label="error"
    >
      {errorMessage}
    </span>
  );
};

export default ErrorMessage;
